<template>
  <div class="content ct2" @click="closeWarn">
      <h3>PPT信息</h3>
      <div class="item clearfix" v-for="(item,index) in pptList" :key="index">
          <div class="fl ct2-left necessary" >
            <label class="ct2-label">
                <img :src="item.DetailImg" alt="" class="left-img"  title="点击切换封面图" :ref="'dimg'+index">
                <div class="df left-up" v-show="!item.DetailImg">
                    <div>
                        <div class="add">+</div>
                        <p>上传PPT预览图</p>
                    </div>
                    <div class="ft12">
                        <p>建议尺寸：720X1280</p>
                    </div>
                </div>
                <input type="file" class="file" @change="choosePreview($event,index)" accept="image/jpg,image/png,image/jpeg,image/tiff,image/webp">
            </label>
            <img :src="item.CoverImg" alt="" style="display: none;">
            <p class="left-nece" v-show="!item.DetailImg && isSend">请上传预览图</p>
          </div>
          <div class="ct2-right">
            <div class="input-box necessary">
                <input type="text" placeholder="请输入名称" required v-model="item.Title">
                <div class="nece-text" v-show="!item.Title && isSend">
                    <span class="warn-icon">!</span> 必填项
                </div>
            </div>
            <div class="input-box necessary" @click.stop="openUploader">
                <div class="file-div" v-html="item.FileName || '点击上传PPT文件'" :class="{active: item.FileName}"></div>
                <div class="nece-text" v-show="!item.FileName && isSend">
                    <span class="warn-icon">!</span> 必填项
                </div>
            </div>
            <!--标签列表-->
            <Labels
                :localLabels="localLabels"
                :DailyLabels="DailyLabels"
                :SystemLabels="SystemLabels"
                :HotLabels="HotLabels"
                :obj="item"
            >
            </Labels>
            <!--<div class="delete-item" @click.stop="deleteItem(index)">删 除</div>-->
          </div>
      </div>
      <!--<div class="df add-next" @click.stop="addNext">
          <span class="add">+</span>
          <span>添加下一个</span>
      </div>-->
      <div class="up-btn" @click.stop="sendPPT" :class="{active: pptList.length==0}">开始上传</div>
      <!-- 提示框 -->
      <Warn ref="warn"></Warn>
      <!-- 确认框 -->
      <Confirm ref="confirm" @handelConfirm="handelConfirm"></Confirm>
      <Uploader ref="uploader"
            :class="{active: isProgress}"
            :isUploaderShow="isUploaderShow" 
            :isDropShow="isDropShow" 
            :isPanelShow="isPanelShow" 
            :isSingleFile="isSingleFile" 
            @getFileName="getFileNameList"
            @closeUploader="closeUploader"
            @removeFile="removeFile"
            @fileSuccess="fileSuccess"
            @fileProgress="fileProgress"
            @fileError="fileError"
            @fileAddError="fileAddError"
        ></Uploader>
        <create-thumb v-show="thumbSetting.img" :setting="thumbSetting" @getThumb="getThumb"></create-thumb>
  </div> 
</template>
<script>
import Labels from "../common/labels"
import Warn from "../common/warn"
import Confirm from "../common/confirm"
import Uploader from "../common/uploader"
import CreateThumb from "../common/createThumb"
import {dataUrlToFile,concat} from "@/assets/js/modules/utils"
import {uploadePhoto,getArticalType,uploadCommonFile,getSystemLabels} from "../../assets/js/modules/shareApi"
import {GetFileForEdit} from "@/assets/js/modules/fileApi"
var PPT = function(){
    this.Id = null;
    this.Title = "";
    this.Labels = [];
    this.FileName = "";     
    this.DetailImg = "";    //详情图
    this.DetailImgFile = null;  //详情图文件
    this.DetailImgExtentsion = "";
    this.CoverImg = "";     //封面图(缩略图)
    this.CoverImgFile = null;
    this.FileObjectKeyCacheKey = "";
    this.PPTType = 1;
    this.FileDetail = {
        FileNo: "",
        Size: "",
        StorageSize: "",
        FileType: 4,
        FileFormat: "ppt"
    };
    this.CoverImgWidth = 0;
    this.CoverImgHeight = 0;
}
export default {
  inject: ['reload'],
  data(){
      return {
          userId: null,
          pptList: [],
          isDeleteShow: false,  //是否显示删除
          isSend: false,        //是否点击了发布,
          HotLabels: [],   //热门标签列表
          DailyLabels: [],     //常用标签列表
          localLabels: [],      //本地标签
          SystemLabels: [],     //系统标签
          confirmValue: false,
          confirmType: 0,   //确认框操作类型, 1--关闭上传文件, 2--移除正在上传的文件 
          fileNameList: [],         //文件名列表
          isUploaderShow: false,    //是否显示上传框
          isDropShow: false,        //是否显示拖拽框
          isPanelShow: true,        //是否显示标题
          isSingleFile: true,       //是否是单文件上传
          isProgress: false,        //文件是否在上传中
          CommentNumbers: 0,
          LikeNumbers: 0,
          nowIndex: 0,
          thumbSetting: {
              img: "",
              autoCropWidth: 240,
              autoCropHeight: 180,
          },
          uploadObj: {},        //用于上传的对象
          fileUploadNum: 0,     //用于判断图片和文件是否都上传完成
          isEdit: false,
      }
  },
  created(){
    this.getQuery();
    if(!this.isEdit){
        this.createItem();
    }
     this.getArticalType();
     this.getSystemLabels();
  },
  mounted(){
    
  },
  components: {
      Warn,
      Confirm,
      Uploader,
      CreateThumb,
      Labels
  },
  methods: {
      //初始化一项
      createItem(){
        let ppt = new PPT();
        this.pptList.push(ppt);
      },
      //获取url参数
      getQuery(){
        if(this.$route.query.uid && this.$route.query.fileId){
            let data = {
                FileNo:this.$route.query.fileId
            };
            this.isEdit = true;
            GetFileForEdit(data).then(res=>{
                if(res.data.Success){
                    //console.log(res);
                    this.pptList.push(res.data.Data);
                    this.$set(this.pptList[0], 'hotLabelShowNum', 5);
                    this.$set(this.pptList[0], 'dayLabelShowNum', 5);  
                    this.pptList[0].FileDetail = res.data.Data.FileDetail || {};
                    this.pptList[0].Labels = res.data.Data.Labels || [];
                    this.uploadObj.DetailImg = res.data.Data.DetailImg;
                    this.uploadObj.CoverImg = res.data.Data.CoverImg;
                }
            })
        }
      },
      //获取分类
      getArticalType(){
        let userInfo = JSON.parse(localStorage.getItem('userInfo'));
        this.userId = userInfo.Id;
        let data = {
            BelongPage: 2,
            UserId: userInfo.Id
        };
        //获取分类类型
        getArticalType(data).then(res=>{
            var result = res.data.Data;
            this.HotLabels = result.HotLabels;
            this.DailyLabels = result.DailyLabels;
        });
        this.getLocalLabels();
      },
      //获取本地标签
      getLocalLabels(){
        this.localLabels = (localStorage.getItem("localLabels") && localStorage.getItem("localLabels").split(" ")) || [];
      },
      //获取系统标签
      getSystemLabels(){
        let data = {PPTType: 1};
        getSystemLabels(data).then(res=>{
            if(res.data.Success){
                this.SystemLabels = res.data.Data;
            }
        })
      },
      //选择预览图
      choosePreview(el,index){
        if(!el.target.files || el.target.files.length==0) return;
        var that = this;
        this.nowIndex = index;
        let file = el.target.files[0];
        if(!this.testImg(file)){
            this.$refs.warn.message("请选择正确的图片格式!");
            el.target.value = "";
            return;
        }
        this.pptList[index].Title = file.name.substring(0,file.name.lastIndexOf('.'));
        this.pptList[index].DetailImgExtentsion = file.name.substring(file.name.lastIndexOf('.')+1,file.name.length);
        this.pptList[index].DetailImgFile = file;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = ()=>{
            this.pptList[index].DetailImg = reader.result;
            let img = new Image();
            img.src = reader.result;
            img.onload = function(){
                let w = img.naturalWidth;
                let h = img.naturalHeight;
                that.thumbSetting.autoCropWidth = 305;
                that.thumbSetting.autoCropHeight = Number((305 / w * h).toFixed(2));
                that.thumbSetting.img = reader.result;
                that.nowIndex = index;
            }
        }
      },
      testImg(file){
        var res = /\.(jpe?g|png|gif|webp|bmp|tiff|svg)/;
        if(res.test(file.name)){
            return true;
        }
        return false;
      },
      //生成缩略图
      getThumb(data){
        this.pptList[this.nowIndex].CoverImg = data.url;
        this.pptList[this.nowIndex].CoverImgWidth = data.width;
        this.pptList[this.nowIndex].CoverImgHeight = data.height;
        this.pptList[this.nowIndex].CoverImgFile = dataUrlToFile(data.url,this.pptList[this.nowIndex].DetailImgFile.name);
        this.thumbSetting.img = "";
      },
      //删除一项(不用)
      deleteItem(index){
        this.nowIndex = index;
        this.confirmType = 3;   //删除一项
        this.$refs.confirm.openConfirm("你确定要删除该项吗?");
      },
      //添加一条(不用)
      addNext(){
         if(this.pptList.length>=10){
             this.$refs.warn.message("一次只能上传十个!");
             return;
         }
         let ppt = new PPT();
         this.pptList.push(ppt);
      },
      //上传ppt
      sendPPT(){
        this.isSend = true;
        //做判断,如果都符合要求,则弹出提示
        if(!this.justifyPPT()){
            this.$refs.warn.message("有必填项未填，请填写!");
        }else{
            let uploader = this.$refs.uploader.uploader;
            this.$refs.warn.message(`请不要关闭当前页面，ppt上传中<span class='animate-ellipse-box'><span class='animate-ellipse'>...</span></span>`,false);
            this.sendPhoto();
            this.sendOriginalFile();
        }
      },
      //验证填写是否符合要求
      justifyPPT(){
        let obj = this.pptList[0];
        if(!obj.DetailImg || !obj.CoverImg || !obj.Title || !obj.FileName) return false;
        return true;
      },
      //上传图片(详情图和缩略图)
      sendPhoto(){
        if(this.uploadObj.DetailImg && this.uploadObj.DetailImg.indexOf("http")==0 ){
            this.fileUploadNum = 2;
            return;
        }
        let formData1 = new window.FormData();
        let formData2 = new window.FormData();
        let obj = this.pptList[this.nowIndex];
        formData1.append('File',obj.DetailImgFile);
        formData1.append('FileExtension',obj.DetailImgExtentsion);
        formData2.append('File',obj.CoverImgFile);
        formData2.append('FileExtension',"png");
        uploadCommonFile(formData1).then(res=>{
            if(res.data.Success){
                this.uploadObj.DetailImg = res.data.Data;
                this.fileUploadNum++;
            }
        });
        uploadCommonFile(formData2).then(res=>{
            if(res.data.Success){
                this.uploadObj.CoverImg = res.data.Data;
                this.fileUploadNum++;
            }
        });
      },
      //分块上传ppt文件
      sendOriginalFile(){
        if(this.$refs.uploader.uploader && !this.$refs.uploader.uploader.fileList[0]){ //编辑时没更改
            this.fileUploadNum++;
        }else if(this.$refs.uploader.uploader.fileList[0].isComplete()){
            this.fileUploadNum++;
        }else{
            this.$refs.uploader.uploader.fileList[0].resume();
        }
      },
      //关闭提示
      closeWarn(){
        this.$refs.warn.closeWarn();
      },
      //操作确认框 {isShow: Boolean, handel: Boolean}
      handelConfirm(data){
        this.$refs.confirm.closeConfirm();
        this.confirmValue = data.handel;
      },
      //上传PPT到后台
      uploadPPT(){
        this.fileUploadNum = 0;
        let obj = this.pptList[this.nowIndex];
        let data = {
            Id: obj.Id,
            UserId: this.userId,
            DetailImg: this.uploadObj.DetailImg,
            CoverImg: this.uploadObj.CoverImg,
            Title: obj.Title,
            Labels: obj.Labels,
            FileName: obj.FileName,
            PPTType: obj.PPTType || 1,
            FileObjectKeyCacheKey: obj.FileObjectKeyCacheKey || "",
            FileDetail: obj.FileDetail,
            CoverImgWidth: obj.CoverImgWidth,
            CoverImgHeight: obj.CoverImgHeight
        };
        uploadePhoto(data).then(res=>{
            //上传完成后弹出提示并清空值
            this.fileUploadNum = 0;
            if(res.data.Success){
                this.setLocalLabels(data.Labels);
                this.$refs.warn.message("PPT上传成功!");
                setTimeout(()=>{
                    this.$router.push("/share/ppt");
                    this.reload();
                },800)
            }
        },err=>{
            this.fileUploadNum = 0;
        })
      },
      //上传失败
      failUpload(){
        this.$refs.warn.message('PPT上传失败，请重新上传!',false);
      },
      //选择分类
      chooseDirectory(name1,id1,name2,id2){
          this.articalObj.ArticleTypeId = id2;
          this.directoryName = name1+">"+name2;
      },
      //获取样式
      getCss(obj, attribute) {
          if (obj.currentStyle) {
              return obj.currentStyle[attribute];
            } else {
                return window.getComputedStyle(obj, null)[attribute];
           }
      },
      //获取文件名列表
      getFileNameList(data){
        this.fileNameList = data;
        this.pptList[0].FileName = this.fileNameList[0];
      },
      //打开上传框并选择文件
      openUploader(){
        this.$refs.uploader.clickme(/\.ppt/);
        this.isUploaderShow = true;
        this.isPanelShow = true;
      },
      //关闭上传框
      closeUploader(){
        if(this.$refs.uploader.uploader.fileList.length==0){
            this.isPanelShow = this.isUploaderShow = false;
            return;
        }
        this.confirmType = 1; //1--关闭上传框
        this.$refs.confirm.openConfirm("关闭将会中断正在上传的文件以及取消上传将要上传的文件<br/>你确定要关闭吗?");
      },
      //文件上传成功
      fileSuccess(res){
        this.pptList[this.nowIndex].FileObjectKeyCacheKey = res[0].Data.IsUpLoaded ? res[0].Data.FileObjectCahcheKey : res[0].Data;
        this.pptList[this.nowIndex].FileDetail.StorageSize = (res[1].size /(1024*1024)).toFixed(2) + "MB";
        this.fileUploadNum++;
      },
      fileProgress(file){
        this.isProgress = true;
      },
      fileError(){
        this.failUpload();
      },
      //文件添加格式错误
      fileAddError(){
        this.$refs.warn.message("请选择ppt文件!");
      },
      //移除一个文件
      removeFile(file){
        if(this.$refs.uploader.uploader.isUploading()){
            this.confirmType = 2;   //2--移除文件
            this.$refs.confirm.openConfirm("移除文件将会取消文件上传<br/>你确定要移除吗?");
        }else{
            this.pptList[this.nowIndex].FileName = "";
            this.$refs.uploader.uploader.removeFile(file);
        }
      },
      //设置本地标签
      setLocalLabels(list){
        let arr = this.localLabels;
        arr = concat(arr,list);
        arr.splice(10,(arr.length-10 > 0 ? arr.length-10 : 0));
        this.localLabels = arr;
        localStorage.setItem('localLabels',arr.join(" "));
      }
  },
  watch: {
      confirmValue: {
          handler: function(){
              if(this.confirmValue ){
                let uploader = this.$refs.uploader.uploader;
                switch(this.confirmType){
                    case 1:     //关闭上传
                        uploader.cancel();
                        this.isPanelShow = this.isUploaderShow = false;
                        if(this.isProgress){
                            this.$refs.warn.message("取消文件上传,请重新上传PPT!");
                        }
                        break;
                    case 2:  //移除文件
                        this.pptList[this.nowIndex].FileName = "";
                        this.$refs.uploader.uploader.removeFile(file);
                        break;
                }
                this.confirmValue = false;
              }
          },
          immediate: true
      },
      fileUploadNum: {
          handler: function(){
              if(this.fileUploadNum==3){
                  this.uploadPPT();
              }
          },
          immediate: true
      }
  },
}
</script>
<style scoped>
.ct2>h3, .ct2 .item{
    padding-left: 30px;
}
.ct2>h3{
    height: 60px;
    line-height: 60px;
    color: #666;
    border-bottom: 1px solid #e7e7e7;
}
.item{
    padding: 30px 0;
    font-size: 14px;
    color: #999;
    border-bottom: 1px solid #e7e7e7;
}
.ct2-label{
    display: block;
    background-color: #f2f3f4;
    position: relative;
    width: 240px;
    min-height: 180px;
    max-height: 560px;
    overflow-x: hidden;
    overflow-y: scroll;
}
.ct2-label::-webkit-scrollbar-track{
    -webkit-box-shadow: inset 0px 20px 20px 13px rgb(243, 243, 243);
    box-shadow: inset 0px 20px 20px 13px rgb(243, 243, 243);
    background-color: #ccc;
}
.ct2-label::-webkit-scrollbar{
    width: 5px;
    background-color: #ccc;
}
.ct2-label::-webkit-scrollbar-thumb{
    background-color: #40ae96;
}
.left-img{
    display: block;
    width: 240px;
    position: relative;
    cursor: pointer;
}
.thumbnail{
    position: absolute;
    z-index: -9999;
    display: none;
    opacity: 0;
}
.left-up{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: 14px;
    color: #999;
    cursor: pointer;
}
.left-up p{
    margin-top: 10px;
}
.ft12{
    font-size: 12px;
}
.add{
    width: 40px;
    height: 40px;
    line-height: 36px;
    border-radius: 50%;
    background-color: #ff9933;
    color: #fff;
    font-size: 36px;
    display: inline-block;
    margin-bottom: 5px;
}
.delete{
    position: absolute;
    right: 10px;
    top: 10px;
    padding: 0 10px;
    background-color: rgba(0,0,0,.8);
    line-height: 20px;
    height: 20px;
    border-radius: 10px;
    color: #fff;
    cursor: pointer;
}
.close{
    font-size: 20px;
    display: inline-block;
    vertical-align: middle;
    margin-top: -4px;
}
.left-nece{
    position: absolute;
    bottom: -30px;
    line-height: 30px;
    color: #ff0000;
}
.ct2-right{
    margin: 0 97px 0 260px;
}
.input-box{
    height: 40px;
    line-height: 40px;
    margin-bottom: 15px;
    box-sizing: border-box;
    position: relative;
}
.necessary{
    position: relative;
}
.necessary::before{
    position: absolute;
    left: -14px;
    content: "●";
    width: 5px;
    height: 5px;
    color: #ff0000;
}
.input-box input, .input-box select{
    width: 100%;
    height: 100%;
    border: 1px solid #e7e7e7;
    border-radius: 5px;
    background-color: #f8f8f8;
    box-sizing: border-box;
    padding: 0 25px 0 15px;
}
.input-box select{
    -webkit-appearance: none;
    color: #999;
}
.file{
    opacity: 0;
    display: none;
}
.input-box .file-div{
    border: 1px solid #e7e7e7;
    border-radius: 5px;
    background-color: #f8f8f8;
    box-sizing: border-box;
    padding: 0 25px 0 15px;
    margin-top: 20px;
}
.input-box .file-div.active{
    color: #666;
}
.nece-text{
    position: absolute;
    right: -70px;
    top: 0;
    height: 100%;
    font-size: 12px;
    color: #ff0000;
}
.warn-icon{
    padding: 0 6.25px;
    border-radius: 50%;
    background-color: #ff0000;
    color: #fff;
}
.label-container{
    -ms-user-select: none;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    border-bottom: 1px solid #e7e7e7;
}
.labelling{
    position: absolute;
    right: 20px;
    top: 0;
    height: 100%;
}
.label-box{
    margin-bottom: 15px;
    overflow:auto;
}
.label{
    line-height: 20px;
    height: 20px;
    padding: 0 12px;
    background-color: #e9e9e9;
    border-radius: 4px;
    margin: 0 10px 10px 0;
    cursor: pointer;
}
.label.active{
    background-color: #6699ff;
    color: #fff;
}
.label-right{
    margin-left: 76px;
}
.label .close{
    display: inline-block;
    font-size: 20px;
    vertical-align: middle;
    margin-top: -5px;
}
.more-label, .less-label{
    cursor: pointer;
}
.delete-item{
    margin-top: 15px;
    float: right;
    line-height: 32px;
    text-align: center;
    width: 90px;
    box-sizing: border-box;
    border: 1px solid #ff9933;
    border-radius: 16px;
    cursor: pointer;
    transition: all 0.3s;
}
.delete-item:hover{
    background-color: #ff9933;
    color: #fff;
}
.add-next{
    height: 112px;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    border-bottom: 1px solid #e7e7e7;
    text-align: center;
    color: #999;
    cursor: pointer;
}
.add-next .add{
    background-color: #e7e7e7;
    margin-right: 10px;
}
.up-btn{
    width: 390px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #ff9933;
    border-radius: 20px;
    text-align: center;
    color: #999;
    margin: 45px auto;
    cursor: pointer;
    transition: all 0.3s;
}
.up-btn:hover{
    background-color: #ff9933;
    color: #fff;
}
.up-btn.active{
    color: #aaa;
    border-color: #ddd;
    background-color: #f8f8f8;
}
.up-btn.active:hover{
    color: #aaa;
    background-color: #f8f8f8;
}
.slide-enter-active, .slide-leave-active{
    transition: all 0.5s ease-out;
}
.slide-enter,.slide-leave-active{
    transform: translateY(10px);
}
.fade-enter-active,
.fade-leave-active {
    transition: all .3s ease-in-out;
}
.fade-enter,.fade-leave-active{
    opacity: 0;
}
.ct2>>>.uploade-box.active .remove-icon{
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/share/shareppt.vue